import { useState, useEffect } from 'react';

const ISBAR_GUIDE_SKIP_KEY = 'surgical_training_isbar_guide_skipped';

export const useISBARGuide = () => {
  const [isGuideSkipped, setIsGuideSkipped] = useState(false);

  useEffect(() => {
    // Check if user has previously skipped the ISBAR guide
    const hasSkipped = localStorage.getItem(ISBAR_GUIDE_SKIP_KEY) === 'true';
    setIsGuideSkipped(hasSkipped);
  }, []);

  const skipGuide = () => {
    localStorage.setItem(ISBAR_GUIDE_SKIP_KEY, 'true');
    setIsGuideSkipped(true);
  };

  const resetGuide = () => {
    localStorage.removeItem(ISBAR_GUIDE_SKIP_KEY);
    setIsGuideSkipped(false);
  };

  const shouldShowGuide = () => {
    return !isGuideSkipped;
  };

  return {
    isGuideSkipped,
    shouldShowGuide,
    skipGuide,
    resetGuide
  };
};